import { toWavyGeojson, toWavyGeojsonOld } from '../../factory'; 

export const NEW_LIVE_DATA = 'NEW_LIVE_DATA';
export const OLD_LIVE_DATA = 'OLD_LIVE_DATA';
export const CLEAR_DATA = 'CLEAR_DATA';

export const onNewLiveData = data => ({ type: NEW_LIVE_DATA, payload: toWavyGeojson(data) })
export const onOldLiveData = data => ({ type: OLD_LIVE_DATA, payload: toWavyGeojsonOld(data) })
export const clearData = () => ({type: CLEAR_DATA})
export const loadOldData = data => ({type: OLD_LIVE_DATA, payload: toWavyGeojsonOld(data) })